import { SearchResultDataDc } from "@evergis/api";
import React, { FC, useMemo } from "react";

import {
  AttributeSeparator,
  FeatureAttribute,
  FeatureAttributeInfo,
  FeatureName,
  FeatureSearchResultContainer,
} from "./styled";
import { getAttributePrefixIcon } from "../../../../utils/getAttributePrefixIcon";
import { getLayerInfo } from "../../../../evergis/core/layer/getLayerInfo";
import { getLayerDefinition } from "../../../../evergis/core/layer/getLayerDefinition";
import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { useShowFeatureCard } from "../../../Table/hooks/useShowFeatureCard";
import { useLayerInfo } from "../../../../components/Dialogs/Access/LayerAccess/hooks/useLayerInfo";

export interface FeatureSearchResultProps {
  layerName: string;
  searchResult: SearchResultDataDc;
}

export const FeatureSearchResult: FC<FeatureSearchResultProps> = ({ layerName, searchResult }) => {
  const showFeature = useShowFeatureCard(layerName);
  const defaultScaleRange = useDefaultScaleRange();
  const { layerInfo } = useLayerInfo(layerName);
  const { id, attributeName, value } = searchResult;

  const renderAttribute = useMemo(() => {
    const info = getLayerInfo(layerInfo, defaultScaleRange);
    const { attributes } = getLayerDefinition(info) || {};
    const { alias, type, subType } = attributes[attributeName] || {};

    return (
      <FeatureAttributeInfo>
        <div>{attributeName}</div>
        <AttributeSeparator />
        {getAttributePrefixIcon(attributeName, type, subType)}
        <div>{alias}</div>
      </FeatureAttributeInfo>
    );
  }, [attributeName, defaultScaleRange, layerInfo]);

  return (
    <FeatureSearchResultContainer>
      <FeatureName onClick={() => showFeature(id)}>{value}</FeatureName>
      <FeatureAttribute>{renderAttribute}</FeatureAttribute>
    </FeatureSearchResultContainer>
  );
};
